import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Store } from '@ngrx/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { SharedService } from 'src/app/services/shared.service';
import { AppState } from 'src/app/store/app.state';

@Component({
  selector: 'app-admin-header',
  templateUrl: './admin-header.component.html',
  styleUrls: ['./admin-header.component.scss']
})
export class AdminHeaderComponent implements OnInit {

  @Input() pageTitle: string = '';

  @ViewChild('sidenav') sidenav!: MatSidenav;

  showSideNav$: Observable<any>;
  showSidenav: Boolean;

  ngUnsubsribe = new Subject();

  constructor(
    private store: Store<AppState>,
    private sharedService: SharedService
  ) {}

  ngOnInit() { }

  toggleSidenav() {
    this.sharedService.toggle();
  }

}
